import { httpRequest, querystringBuilderByObject } from '@common/util/api-common.util';

export default class DragDropApi {
  static moverLaminas(laminaRequest) {
    return httpRequest('lamina/mover-lote', 'PATCH', laminaRequest);
  }

  static moverCassetes(casseteRequest) {
    return httpRequest('cassetes/mover-lote', 'PATCH', casseteRequest);
  }

  static criarLaminas(laminasRequest) {
    return httpRequest('lamina/criar-lote', 'POST', laminasRequest);
  }

  static arquivarMaterias(arquivamentosRequest) {
    return httpRequest('arquivamento/mover-lote', 'PATCH', arquivamentosRequest);
  }

  static requisicaoMateriais(requisicaoMateriaisRequest){
    return httpRequest('RequisicaoBlocosLaminas/mover-lote', 'PATCH', requisicaoMateriaisRequest);
  }

  // Organizar Lote  
  static async getLaminasHisto(NrLamina) {
    const obj = { NrLamina };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`lamina/get-lamina-por-nr-lamina${query}`);
  }

  static async getLaminasCito(NrLamina) {
    const obj = { NrLamina };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`citologia/get-lamina-por-nr-lamina${query}`);
  }

  static async getLaminasImuno(NrLamina) {
    const obj = { NrLamina };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`lamina/imuno/get-lamina-por-nr-lamina${query}`);
  }

  // Cassete e HL Bloco
  static async getCassetes(NrBloco) {
    const obj = { NrBloco };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`cassetes/get-cassete-por-nr-bloco${query}`);
  }

  static async getArquivamento(CdIdentificacaoBlocoLamina) {
    const obj = { CdIdentificacaoBlocoLamina };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`arquivamento/get-item-por-nr-identificacao${query}`);
  }

  static async getRequisicao(CdIdentificacaoBlocoLamina) {
    const obj = { CdIdentificacaoBlocoLamina };
    const query = querystringBuilderByObject(obj);
    return httpRequest(`RequisicaoBlocosLaminas/get-item-por-nr-identificacao${query}`);
  }
}


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/dragdrop.api.js